import React from 'react';
import { Badge } from 'reactstrap';
import Isvg from 'react-inlinesvg';
import TickIcon from 'app/images/icons/tick.svg';
import ProcessingIcon from 'app/images/icons/refresh.svg';
import { parsePaymentStatusText } from 'app/ducks/paymentEvents/selectors';

interface IStatusBlock {
  paymentStatus?: string;
  transferStatus?: string;
  adminStatus?: string;
  forfeitStatus?: string;
  activeStatus?: string;
}

interface IProps {
  formattedPaymentText?: string;
  numberOfObjects?: number;
  paymentText?: string;
  className?: string;
  defaultText?: string;
  teamStatus?: IStatusBlock;
  otherTeamStatus?: IStatusBlock;
  tick?: boolean;
  noActive?: boolean;
}

export default class StatusBadge extends React.PureComponent<IProps> {
  static defaultProps = {
    formattedPaymentText: undefined,
    numberOfObjects: undefined,
    paymentText: undefined,
    noActive: false,
    className: undefined,
    teamStatus: {},
    otherTeamStatus: {},
    defaultText: 'Unpaid',
    tick: true,
  };

  parsePaymentStatusText = (
    status = 'pending',
    otherTeamStatus = 'pending',
    defaultText = this.props.defaultText,
  ): string => {
    let parsedText = defaultText;
    if (status === 'paid') {
      parsedText = 'Teammo';
    }
    if (status === 'active' && !this.props.noActive) {
      parsedText = 'Active';
    }
    if (status === 'cancelled') {
      parsedText = 'Cancelled';
    }
    if (status === 'inactive') {
      parsedText = 'Inactive';
    }
    if (status === 'collected') {
      parsedText = 'Collected';
    }
    if (status === 'paid-transferred') {
      parsedText = 'Teammo';
    }
    if (status === 'paid-refunded') {
      parsedText = 'Refunded';
    }
    if (status === 'refunded') {
      parsedText = 'Refunded';
    }
    if (status === 'refund-pending') {
      parsedText = 'Processing Refund';
    }
    if (status === 'partially-refunded') {
      parsedText = 'Partially Refunded';
    }
    if (status === 'no-show' || otherTeamStatus === 'no-show') {
      parsedText = 'No-show';
    }
    if (status === 'walkover' || otherTeamStatus === 'walkover') {
      parsedText = 'Forfeit';
    }
    if (status === 'cancelled') {
      parsedText = 'Cancelled';
    }
    if (status === 'paid-cash') {
      parsedText = 'Cash';
    }
    if (status === 'paid-eftpos') {
      parsedText = 'Eftpos';
    }
    if (status === 'paid-prepaid') {
      parsedText = 'Pre-paid';
    }
    if (status === 'transfer-required') {
      parsedText = 'Transfer Pending';
    }
    if (status === 'transferred') {
      parsedText = 'Transferred';
    }
    if (status === 'refunded') {
      parsedText = 'Refunded';
    }
    if (status === 'owing') {
      parsedText = 'Owing';
    }
    if (status === 'up-to-date') {
      parsedText = 'Up-to-date';
    }
    if (status === 'overdue') {
      parsedText = 'Overdue';
    }
    return parsedText;
  }

  parsePaymentStatusColour = (
    status = 'pending',
    otherTeamStatus = 'pending',
    defaultColour = 'grey',
  ) => {
    let parsedColour = defaultColour;
    if (status === 'paid') {
      parsedColour = 'purple';
    }
    if (status === 'cancelled') {
      parsedColour = 'black';
    }
    if (status === 'active') {
      parsedColour = 'green';
    }
    if (status === 'inactive') {
      parsedColour = 'grey';
    }
    if (status === 'paid-cash') {
      parsedColour = 'orange';
    }
    if (status === 'paid-eftpos') {
      parsedColour = 'blue';
    }
    if (status === 'paid-prepaid') {
      parsedColour = 'yellow';
    }
    if (status === 'paid-transferred') {
      parsedColour = 'purple';
    }
    if (status === 'paid-refunded') {
      parsedColour = 'purple';
    }
    if (status === 'pending') {
      parsedColour = 'grey';
    }
    if (status === 'refunded') {
      parsedColour = 'dark-purple';
    }
    if (status === 'refund-pending') {
      parsedColour = 'dark-purple';
    }
    if (status === 'partially-refunded') {
      parsedColour = 'dark-purple';
    }
    if (status === 'transfer-required') {
      parsedColour = 'dark-purple';
    }
    if (status === 'transferred') {
      parsedColour = 'purple';
    }
    if (status === 'refunded') {
      parsedColour = 'black';
    }
    if (status === 'no-show' || otherTeamStatus === 'walkover') {
      parsedColour = 'black';
    }
    if (status === 'walkover' || otherTeamStatus === 'walkover') {
      parsedColour = 'black';
    }
    return parsedColour;
  }

  badgeColor = (paymentText) => {
    let color = 'grey';
    let checked = false;
    let processing = false;
    if (paymentText === 'pending') {
      color = 'purple';
    }
    if (paymentText === 'Overdue') {
      color = 'red';
    }
    if (paymentText === 'Cancelled') {
      color = 'black';
    }
    if (paymentText === 'Walkover') {
      color = 'black';
    }
    if (paymentText === 'Forfeit') {
      color = 'black';
    }
    if (paymentText === 'Opposition Forfeit') {
      color = 'black';
    }
    if (paymentText === 'Opposition No-show') {
      color = 'black';
    }
    if (paymentText === 'No-show') {
      color = 'black';
    }
    if (paymentText === 'Up-to-date') {
      color = 'green';
    }
    if (paymentText === 'Active') {
      color = 'green';
    }
    if (paymentText === 'Collecting' || paymentText === 'In Progress') {
      color = 'purple';
      processing = true;
    }
    if (paymentText === 'Collected') {
      color = 'green';
      checked = true;
    }
    if (paymentText === 'Owing') {
      color = 'medium-grey';
    }
    if (paymentText === 'Setting Up') {
      color = 'medium-grey';
    }
    if (paymentText === 'Overdue') {
      color = 'red';
    }
    if (paymentText === 'Transferred') {
      color = 'dark-purple';
    }
    if (paymentText === 'Transfer Pending') {
      color = 'dark-purple';
    }
    if (paymentText === 'Processing Refund') {
      color = 'dark-purple';
    }
    if (paymentText === 'Refunded') {
      color = 'dark-purple';
    }
    if (paymentText === 'Partially Refunded') {
      color = 'dark-purple';
    }
    if (
      paymentText === 'Paid'
      || paymentText === 'Paid Teammo'
      || paymentText === 'Teammo'
      || paymentText === 'Paid via Transfer'
    ) {
      color = 'purple';
      checked = true;
    }
    if (paymentText === 'Paid Cash' || paymentText === 'Cash') {
      color = 'orange';
      checked = true;
    }
    if (paymentText === 'Paid Eftpos' || paymentText === 'Eftpos') {
      color = 'blue';
      checked = true;
    }
    if (paymentText === 'Paid Pre-paid' || paymentText === 'Pre-paid') {
      color = 'yellow';
      checked = true;
    }
    return [color, checked, processing];
  };

  render(): React.ReactNode {
    let paymentText;
    if (!_.isEmpty(this.props.formattedPaymentText)) {
      paymentText = this.props.formattedPaymentText;
    } else if (!_.isEmpty(this.props.teamStatus) || !_.isEmpty(this.props.otherTeamStatus)) {
      paymentText = parsePaymentStatusText(this.props.teamStatus, this.props.otherTeamStatus, this.props.defaultText, true);
    } else {
      paymentText = this.parsePaymentStatusText(this.props.paymentText);
    }
    const [badgeColor, checked, processing] = this.badgeColor(paymentText);

    return (
      <Badge
        className={`${this.props.className} payment-badge`}
        color={badgeColor}
      >
        {this.props.numberOfObjects !== undefined && (`${this.props.numberOfObjects} `)}
        {paymentText}
        {this.props.tick && checked && <Isvg className="tick" src={TickIcon} />}
        {this.props.tick && processing && <Isvg className="processing" src={ProcessingIcon} />}
      </Badge>
    );
  }
}
